import axios from 'axios';
import {jwtDecode} from "jwt-decode";

export class AuthFirestore {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  async createUserWithEmailAndPassword(email, password) {
    try {
      const response = await axios.post(`${this.apiUrl}/register`, { email, password });
      if(response.data) {
        const response = await axios.post(`${this.apiUrl}/login`, {email, password});
        const {token, refreshToken} = response.data;
        localStorage.setItem('jwtToken', token);
        localStorage.setItem('refreshToken', refreshToken);


      }
    } catch (error) {
      console.error('Error registering user:', error);
      throw error;
    }
  }

  async signInWithEmailAndPassword(email, password) {
    try {
      const response = await axios.post(`${this.apiUrl}/login`, { email, password });
      const { token, refreshToken } = response.data;
      localStorage.setItem('jwtToken', token);
      localStorage.setItem('refreshToken', refreshToken);

      return jwtDecode(token);
    } catch (error) {
      console.error('Error logging in:', error);
      throw error;
    }
  }

  async signOut() {
    localStorage.removeItem('jwtToken');
  }

  get currentUser() {
    const token = localStorage.getItem('jwtToken');
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);

      return {...decoded, providerData: [decoded]};
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  async sendPasswordResetEmail(email) {
    try {
      const response = await axios.post(`${this.apiUrl}/forgot-password`, { email });
      return response.data;
    } catch (error) {
      console.error('Error sending reset password email:', error);
      throw error;
    }
  }

  async resetPassword(token, newPassword) {
    try {
      const response = await axios.post(`${this.apiUrl}/reset-password`, { token, newPassword });
      return response.data;
    } catch (error) {
      console.error('Error resetting password:', error);
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/firb-auth.js